import { createPortal } from 'react-dom';
import { useIsMobile } from '@/shared/hooks/useMediaQuery';
import Toast from './Toast';

export default function ToastContainer({ toasts, onDismiss, theme: t }) {
  const mobile = useIsMobile();

  if (!toasts.length || !t) return null;

  const container = (
    <div
      style={{
        position: 'fixed',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        ...(mobile
          ? { top: 16, left: '50%', transform: 'translateX(-50%)' }
          : { bottom: 24, right: 24 }),
      }}
    >
      <style>{`
        @keyframes toast-in {
          from { opacity: 0; transform: translateY(${mobile ? '-12px' : '12px'}); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          message={toast.message}
          type={toast.type}
          theme={t}
          onDismiss={() => onDismiss(toast.id)}
        />
      ))}
    </div>
  );

  return createPortal(container, document.body);
}
